import React from "react";
import { Grid, Typography, Paper, Box } from "@mui/material";

const FarmerLandNoResponse = ({ val }) => {
  return (
    <>
      <div
        style={{
          padding: "10px",
          backgroundColor: "#ffffff",
          borderRadius: 2,
          marginTop: "4px",
          marginBottom: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 3,
            border: "2px dashed #FF8C00",
            borderRadius: 2,
            minHeight: { xs: "200px", sm: "150px" },
            textAlign: "center",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid
              item
              xs={12}
              sm={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: { xs: 2, sm: 0 },
              }}
            >
              <img
                src="https://cdn.vectorstock.com/i/500p/04/11/no-data-empty-concept-vector-41830411.jpg"
                alt="No Trade"
                style={{
                  width: "100%", 
                  maxWidth: "200px",
                  height: "auto", 
                }}
              />
            </Grid>

            <Grid item xs={12} sm={8}>
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#FF8C00" }}
              >
                You don’t have any Farm data yet!
              </Typography>
              <Typography
                variant="subtitle1"
                color="textSecondary"
                sx={{ mt: 1, maxWidth: "500px", mx: "auto" }}
              >
                Start by adding plot and land details to manage your farm
                efficiently.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default FarmerLandNoResponse;
